import './styles.scss'

const Empty = () => {
    return (
        <div className="empty">
            <div className="icon">
                <i className='bx bx-book'></i>
            </div>
            <div className="text">Click on a note to view it.</div>
        </div>
    )
}

export default Empty